import { Config } from "./Global";
import { getUserToken, logout } from "./AuthService";
import { message } from 'antd';
let moment = require('moment');

export const apiMethods = {
  post,
  get,
  getRaw,
  remove,
  put,
  patch,
  getPDF
};
const AUTHENTICATION_CODE = [401];

function fetch_output(URL, requestOptions, Auth) {
  if (Auth) {
    requestOptions['headers']['Authorization'] = 'Token ' + getUserToken();
  }
  return fetch(URL, requestOptions)
    .then(response => {

      if (!response.ok) {
        if (AUTHENTICATION_CODE.indexOf(response.status) >= 0) {
          logout();
          const error = 'User token is expired';
          message.error(error);
          return Promise.reject(message)
        }
        if (response.status === 500) {
          let error = 'Sorry, we are doing a little maintenance on the site to improve it.We will be back shortly.';
          message.info(error);
          return Promise.reject(error)
        }
        return response.json().then(data => {
          let error = data['error'];
          for (const [key, value] of Object.entries(error)) {
            if(error['non_field_errors'] === 'Invalid token.')
              logout();
            else if (error['non_field_errors'])
              message.error(error['non_field_errors']);
            else
              message.error(key.toUpperCase() + " - " + value)
          }
          return Promise.reject("Check the fields for errors.");
        }
        )
      }
      return new Promise((resolve) => {
        resolve(response)
      })
    })
}

function post(URL, requestData, Auth, headers={'Content-Type': 'application/json' }) {
  const requestOptions = { method: 'POST', headers: headers, body: requestData };
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
    .then(response => {
      return response.json()
    })
    .then(response => {
      if (response.data.success_message) {
        message.success(response.data.success_message);
      }
      return response.data;
    });
}
function put(URL, requestData, Auth, headers={'Content-Type': 'application/json' }) {
  const requestOptions = { method: 'PUT', headers: headers, body: requestData };
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
    .then(response => {
      return response.json()
    })
    .then(response => {
      if (response.data.success_message) {
        message.success(response.data.success_message);
      }
      return response.data;
    });
}
function patch(URL, requestData, Auth, headers={'Content-Type': 'application/json' }) {
  const requestOptions = { method: 'PATCH', headers: headers, body: requestData };
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
    .then(response => {
      return response.json()
    })
    .then(response => {
      if (response.data.success_message) {
        message.success(response.data.success_message);
      }
      return response.data;
    });
}

function getRaw(URL, requestData, Auth) {
  const requestOptions = { method: 'GET', headers: { 'Content-Type': 'application/json' } };
  requestData = Object.entries(requestData);
  requestData = requestData.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
  if (requestData)
    URL += "?" + requestData;
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
      .then(response => {
        return response
      })
}

function get(URL, requestData, Auth) {
  const requestOptions = { method: 'GET', headers: { 'Content-Type': 'application/json' } };
  requestData = Object.entries(requestData);
  requestData = requestData.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
  if (requestData)
    URL += "?" + requestData;
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
    .then(response => {
      return response.json()
    })
}

function remove(URL, requestData, Auth) {
  const requestOptions = { method: 'DELETE', headers: { 'Content-Type': 'application/json' } };
  requestData = Object.entries(requestData);
  requestData = requestData.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
  if (requestData)
    URL += "?" + requestData;
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
    .then(response => {
      return Promise.resolve('Successful');
    })
}


function updateImage(URL, requestData, Auth) {
  const requestOptions = { method: 'PATCH', headers: {'Content-Type': 'multipart/form-data', 'Accept': 'application/json',}, body: requestData };
  return fetch_output(Config['domain'] + URL, requestOptions, Auth)
    .then(response => {
      return response.json()
    })
    .then(response => {
      if (response.data.success_message) {
        message.success(response.data.success_message);
      }
      return response.data;
    });
}

function getPDF(url, requestData, Auth) {
  const requestOptions = { method: 'GET', responseType: 'blob', headers: { 'Content-Type': 'application/pdf' } };
  requestData = Object.entries(requestData);
  requestData = requestData.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`).join('&');
  if (requestData)
    url += "?" + requestData;
  return fetch_output(Config['domain'] + url, requestOptions, Auth)
    .then(response => {
      let link = document.createElement('a');
      response.blob().then(function (BlobData) {
        let fileURL = URL.createObjectURL(BlobData);
        link.href = fileURL;
        link.setAttribute('target',"_blank");
        link.download = "download" + moment().format() + ".pdf";
        link.click()
        return {status: 'Downloaded'}
      })
    })
}




// WEBPACK FOOTER //
// ./src/controller/Request.jsx